import { InitialIntegrationReducer } from "../../../_services/store/InitialIntegrationReducer";
import { createSlice } from "@reduxjs/toolkit";
import { INITIAL_NEW_CONFIGURATION, integrationReducerActions } from "../../../_commons/integration.reducer";

export const initialAdyenReducer = {
    ...new InitialIntegrationReducer(),
    newConfiguration: {
        ...INITIAL_NEW_CONFIGURATION,
    },
};

const adyenSlice = createSlice({
    name: "Adyen",
    initialState: { ...initialAdyenReducer, files: [] },
    reducers: {
        ...integrationReducerActions,
        uploadDataFileRequest(state) {
            state.submitted = true;
            state.isImportLoading = true;
            state.importErrorMessage = null;
            state.importSuccessMessage = null;
        },
        uploadDataFileSuccess(state, action) {
            state.configuration = action.payload;
            state.editConfiguration = action.payload;
            state.isImportLoading = false;
            state.imported = true;
            state.importSuccessMessage = "Der Import wurde erfolgreich gestartet";
        },
        uploadDataFileFailure(state, action) {
            state.isImportLoading = false;
            state.imported = false;
            state.importErrorMessage = action.payload;
        },
        setImportRequest(state, action){
            state.isImportLoading = false;
            state.imported = false;
            state.files = [...action.payload];
        }
    }
});

export default adyenSlice;
